import Category from '../Form/Category'

const PageCategoryNew = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
  
  return (
    <div id="ms-profile">

          <div className="ms-section">
            <div className="ms-tab-profile ms-payment">
              <div className="ms-lateral-b">
                <div className="ms-body-menu-profile">
                  <div className="ms-info-menu-selected">
                    <div className="ms-title">Nueva Categoria</div>
                    <Category type_page="new" user={user} />
                  </div>            
                </div>
            </div>
              
            </div>
            </div>

          </div>
  )

}

export default PageCategoryNew;